import React, {useContext} from "react";
import {BoShowContext} from "../context/bo-show-context.jsx";
import {formatCnpjToView} from "../utils/bo-show-utils.js";

const BoShowCompanies = () => {
    const {boData} = useContext(BoShowContext);
    const companyList = boData?.companyList;

    if (!companyList?.length) return null;

    return (
        <>
            {
                companyList.map((company, index) => (
                    <article key={company?.itemId ?? index} className={"space-y-4"}>
                        <h2 className={"resume-title"}>EMPRESA - {index + 1}</h2>

                        <section className={"grid grid-cols-3 gap-2"}>
                            <p className={"col-span-2"}>Nome: <span className={"info"}>{company?.name ?? ""}</span></p>
                            <p>CNPJ: <span className={"info !font-bold"}>{formatCnpjToView(company?.cnpj)}</span></p>
                            <p className={"col-span-2"}>Email: <span className={"info"}>{company?.email ?? ""}</span></p>
                            <p>Telefone: <span className={"info"}>{company?.phone ?? ""}</span></p>
                        </section>

                        <section className={"space-y-2"}>
                            <h3 className={"!font-normal"}>Endereços</h3>

                            <div className={"grid grid-cols-3 gap-2"}>
                                <p className={"col-span-2"}>Logradouro: <span className={"info"}>{company?.address?.address ?? ""}</span></p>
                                <p>Número: <span className={"info"}>{company?.address?.number ?? ""}</span></p>
                                <p className={"col-span-2"}>Bairro: <span className={"info"}>{company?.address?.neighborhood ?? ""}</span></p>
                                <p>Município: <span className={"info"}>{company?.address?.city ?? ""}</span></p>
                                <p className={"col-span-2"}>Complemento: <span className={"info"}>{company?.address?.complement ?? ""}</span></p>
                                <p>CEP: <span className={"info"}>{company?.address?.zipCode ?? ""}</span></p>
                            </div>
                        </section>
                    </article>
                ))
            }
        </>
    );
};

export default BoShowCompanies;
